var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioOnButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #042b62;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.17,1038.55c-265,0-479.83-214.83-479.83-479.83S275.17,78.89,540.17,78.89s479.83,214.83,479.83,479.83-214.83,479.83-479.83,479.83ZM540.17,942.72c101.9,0,199.54-40.49,271.52-112.48,71.99-71.99,112.48-169.62,112.48-271.52s-40.49-199.54-112.48-271.52c-71.99-71.99-169.62-112.48-271.52-112.48s-199.54,40.49-271.52,112.48-112.48,169.62-112.48,271.52,40.49,199.54,112.48,271.52,169.62,112.48,271.52,112.48ZM540.17,798.75c-63.66,0-124.63-25.2-169.62-70.19s-70.19-105.95-70.19-169.62,25.2-124.63,70.19-169.62,105.95-70.19,169.62-70.19,124.63,25.2,169.62,70.19c44.99,44.99,70.19,105.95,70.19,169.62s-25.2,124.63-70.19,169.62c-44.99,44.77-105.95,70.19-169.62,70.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOnButton);
export default __webpack_public_path__ + "static/media/radio-on-button.b6966c967aeef9c585b39a72f0732426.svg";
export { ForwardRef as ReactComponent };